import React, { Component } from 'react'
import './style.css'
// import image from './../image.png'

export default class Container extends Component {

  constructor(props) {
    super(props)

    this.state = {	
      isScrolled: false,	
      hasZoom: false,	
      zoomLevel: {	
        current: 1,	
        max: 2	
      },	
      imageZoom:false,	
      imageWidth:400,	
      imageHeight:400,	
      ishasZoom: false,	
      isZoomed: false,
      offset: {
        x: 0, y: 0
      },
    };

    this.zoomArea = React.createRef();
    this.contentElement = React.createRef();

    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

  }


  onZoomIn = () => {
    const { zoomLevel } = this.state;
    let finalZoomLevel = zoomLevel.current < 1.5 ? 1.5 : 2;
    if (zoomLevel.current < zoomLevel.max) {
      this.setState({
        zoomLevel: {
          ...zoomLevel,
          current: finalZoomLevel
        },
      })
    }
  }


  onZoomOut = () => {
    const { zoomLevel } = this.state;
    let finalZoomLevel = zoomLevel.current > 1.5 ? 1.5 : 1;
    if (zoomLevel.current > 1) {
      this.setState({
        zoomLevel: {
          ...zoomLevel,
          current: finalZoomLevel
        },
      })
    }
  }

  onChangeZoomRange = (e) => {
    const { zoomLevel } = this.state;
    this.setState({
      zoomLevel: {
        ...zoomLevel,
        current: parseFloat(e.target.value)
      },
    }, () => {
    })
  }

  initializeZoomArea() {

    this.setState({
      zoomFactor: isNaN(this.getInitialZoomFactor()) ? 1 : this.getInitialZoomFactor()
    }, () => {
      this.resetOffset();
    });

  }

  getInitialZoomFactor() {
    if (!this.zoomArea.current) return 1;
    const xZoomFactor = this.zoomArea.current.offsetWidth / this.contentElement.current.offsetWidth;
    const yZoomFactor = this.zoomArea.current.offsetHeight / this.contentElement.current.offsetHeight;
    let factor;
    if (xZoomFactor < 1 || yZoomFactor < 1) {
      // If any axis is already too small, use the biggest factor
      factor = Math.max(xZoomFactor, yZoomFactor);
    } else {
      // Both axis are small enough, use the smallest factor
      factor = Math.min(xZoomFactor, yZoomFactor);
    }
    // Does not allow the zoom to go under 1 (minZoom)
    if (this.props.externalZoomFactor > 1) {
      return Math.abs(factor * this.props.externalZoomFactor);
    }
    if (this.props.minZoom >= 0) {
      return Math.max(factor, this.props.minZoom);
    }
    return factor;
  }

  resetOffset() {
    this.setState({
      offset: this.computeInitialOffset()
    });
  }

  sanitizeOffset(offset) {
    const maxOffsets = this.getMaxOffsets();
    const maxX = maxOffsets.x,
      maxY = maxOffsets.y,
      maxOffsetX = Math.max(maxX, 0),
      maxOffsetY = Math.max(maxY, 0),
      minOffsetX = Math.min(maxX, 0),
      minOffsetY = Math.min(maxY, 0);
    return {
      x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
      y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
    };
  }

  getMaxOffsets() {
    const elWidth = this.contentElement.current.offsetWidth * this.state.zoomFactor;
    const elHeight = this.contentElement.current.offsetHeight * this.state.zoomFactor;
    const maxX = elWidth - this.zoomArea.current.offsetWidth,
      maxY = elHeight - this.zoomArea.current.offsetHeight;

    return { x: maxX, y: maxY };
  }

  computeInitialOffset() {
    //let x = -(Math.abs(this.contentElement.current.offsetWidth * this.state.zoomFactor - this.zoomArea.current.offsetWidth) / 2);
    let x = (this.contentElement.current.offsetWidth * this.state.zoomFactor - this.zoomArea.current.offsetWidth) / 2;
    let contentOffsetHeight;
    let isScrollPresent = this.contentElement.current.offsetHeight > this.zoomArea.current.offsetHeight;
    let adjustFactor;
    if (isScrollPresent) {
      adjustFactor = 0;
      contentOffsetHeight = (this.zoomArea.current.offsetHeight - adjustFactor);
    } else {
      contentOffsetHeight = this.contentElement.current.offsetHeight;
    }
    let y = ((contentOffsetHeight * this.state.zoomFactor - this.zoomArea.current.offsetHeight) / 2);
    if (isScrollPresent) {
      y = ((contentOffsetHeight * this.props.externalZoomFactor - this.zoomArea.current.offsetHeight) / 2);

    }

    let finalOffset = this.sanitizeOffset({ x, y })
    return finalOffset;
    //return (this.isTouchDevice || (this.props.externalZoomFactor === 1 && !this.isTouchDevice)) ? this.sanitizeOffset({x,y}) : {x: -x, y: -y};
  }

  createStyle() {
    const { offset, zoomFactor, isTouching, zoomLevel } = this.state;
    
    const offsetX = -offset.x / zoomLevel.current;
    const offsetY = -offset.y / zoomLevel.current;
    const hasScaleRatio = !isNaN(zoomLevel.current);
    const transform3d = `scale3d(${zoomLevel.current}, ${zoomLevel.current}, ${zoomLevel.current}) translate3d(${offsetX}px, ${offsetY}px, 0)`;
    const transform2d = `scale(${zoomLevel.current}) translate(${offsetX}px, ${offsetY}px)`;
    // const zoom = { zoomLevel.current }
    return {
      transform: isTouching ? transform2d : transform2d,
      visibility: hasScaleRatio || this.props.imageZoom ? 'visible' : 'hidden',
    };
  }

  handleClick = () => {
    if (this.state.zoomLevel.current < 1.5) {
      this.setState({
        zoomLevel: {
          current: 1.5
        }
      })
    }
    else {
      this.setState({
        zoomLevel: {
          current: 1
        }
      })
    }
  }

  handleDrag(touch) {
    this.drag(touch, this.state.lastTouch);
    this.setState(({ offset }) => ({
      offset: this.sanitizeOffset(offset)
    }));
    this.setState({
      lastTouch: touch,
      isZoomImageDrag: true
    });
  }

  drag(center, lastCenter) {
    if (!lastCenter) return;
    this.setState({
      isScroll: true
    });
    this.addOffset({
      x: -(center.x - lastCenter.x),
      y: -(center.y - lastCenter.y),
    });
  }

  addOffset({ x, y }) {
    this.setState(({ offset }) => ({
      offset: {
        x: offset.x + x,
        y: offset.y + y,
      }
    }));
  }

  render() {

    const contentStyle = this.createStyle();

    return (
      <div id="myModal" className="img-modal renderer-wrapper" onTouchStart={(e) => this.handleMapMove(e)}>
        <React.Fragment>
          <div className={"zoom-close-section"}><div className={"pin-close"}><svg className={"zoom-close-icon"} width="28" height="28" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M13.2426 4.75729C12.9823 4.49694 12.5602 4.49694 12.2998 4.75729L9 8.05712L5.70017 4.75729C5.43982 4.49694 5.01771 4.49694 4.75736 4.75729C4.49701 5.01764 4.49701 5.43975 4.75736 5.7001L8.05719 8.99993L4.75736 12.2998C4.49701 12.5601 4.49701 12.9822 4.75736 13.2426C5.01771 13.5029 5.43982 13.5029 5.70017 13.2426L9 9.94274L12.2998 13.2426C12.5602 13.5029 12.9823 13.5029 13.2426 13.2426C13.503 12.9822 13.503 12.5601 13.2426 12.2998L9.94281 8.99993L13.2426 5.7001C13.503 5.43975 13.503 5.01764 13.2426 4.75729Z" fill="white"></path></svg>
          </div>
          </div>
          <div className={'zoom-section'}>
            
            {this.state.zoomLevel.current > 1 || this.state.ishasZoom ?
              <div className={`pin-zoom ${this.isTouchDevice ? 'mobile-pin-zoom' : " "}`} onClick={(e) => this.onReset()}>
                <svg className="pinch-zoom-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M16.4879 8.48787C16.6769 8.67686 16.543 9 16.2757 9H11.3C11.1343 9 11 8.86569 11 8.7V3.72426C11 3.45699 11.3231 3.32314 11.5121 3.51213L16.4879 8.48787Z" fill="white" />
                  <path d="M18.5 1.5L12.5 7.5" stroke="white" strokeWidth="1.3" strokeLinecap="round" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M3.51213 11.5121C3.32314 11.3231 3.45699 11 3.72426 11H8.7C8.86569 11 9 11.1343 9 11.3V16.2757C9 16.543 8.67686 16.6769 8.48787 16.4879L3.51213 11.5121Z" fill="white" />
                  <path d="M7.5 12.5L1.5 18.5" stroke="white" strokeWidth="1.3" strokeLinecap="round" />
                </svg>
              </div>
              : null}

            
              <div className={'zoom-factor'}>
                <div className={`decrease-zoom remove-decrease-click `} onClick={(e) => this.onZoomOut()}>
                <svg className="minus-zoom-icon" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="7" y="12.3501" width="12" height="1.3" rx="0.65" fill="white" />
                </svg>
                </div>
                <div className={'main-progress-zoom'}>
                  <input className={'input-range'} type="range" min="1" max="2" step="0.01" value={this.state.zoomLevel.current} onChange={(e) => this.onChangeZoomRange(e)} />
                </div>
                <div className={`increase-zoom ${this.state.zoomLevel.current === 2 ? 'remove-increase-click' : ''}`} onClick={(e) => this.onZoomIn()}>
                <svg className="plus-zoom-icon" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M13 7C12.641 7 12.35 7.29101 12.35 7.65V12.35H7.65C7.29101 12.35 7 12.641 7 13C7 13.359 7.29101 13.65 7.65 13.65H12.35V18.35C12.35 18.709 12.641 19 13 19C13.359 19 13.65 18.709 13.65 18.35V13.65H18.35C18.709 13.65 19 13.359 19 13C19 12.641 18.709 12.35 18.35 12.35H13.65V7.65C13.65 7.29101 13.359 7 13 7Z" fill="white" />
                </svg>
                </div>
              </div>
            
          </div>
        </React.Fragment>
        
          <div className={'Dzkqm'} 
          // imageZoom={this.state.imageZoom} 
          // minZoom={null} 
          width={this.state.imageWidth} 
          ref={this.zoomArea}
            // isMobile={this.props.isMobile}
            // externalZoomFactor={this.state.zoomLevel.current}
            // flashcardId={this.props.flashcardId}
            // isTouchDevice={this.isTouchDevice}
            // isZoomed={this.state.ishasZoom}
            // onActionFlashcard={() => this.onImageClick()}
            // canEditExercise={this.props.canEditExercise}
            // resetZoom={this.setZoomReset}
            // listFlashcardId={this.props.listFlashcardId}
            // selectedSide={this.props.selectedSide}
            >
            <div style={{ 'width': '595px' }} 
            // isZoomed={this.state.zoomLevel.current > 1}
            ref={this.contentElement}
            >
              <img className="modal-contents" id="img01" alt="" src={this.props.imageUrl} style={contentStyle}/>
            </div>
          </div>
        
      </div>

    )
  }

  onTouchMove(event) {
    // if (this.props.isDisabled) return;
    if (!this.state.isTouching) return;
    const touches = this.mapTouches(this.isTouchDevice ? event.touches : event);
    const maxOffsets = this.getMaxOffsets();
    // if (touches && touches.length === 1 && maxOffsets.x < 2 && maxOffsets.y < 2) {
    //   return;
    // }
    this.cancelEvent(event);
    const touch = touches && touches[0];
    if (!this.state.lastTouch) {
      this.setState({
        lastTouch: touch
      });
      return;
    }
    if (touches && touches.length === 2) {
      this.setState({
        isScroll: true
      });
      this.handleZoom(touches, calculateScale(this.state.startTouches, touches));
      return;
    }
    this.handleDrag(touch);

    this.setState({
      lastTouch: touch
    });
  }

  onTouchStart(event) {
    // if (this.props.isDisabled) return;
    if (this.isTouchDevice && !event.touches) return;
    const touches = this.mapTouches(this.isTouchDevice ? event.touches : event);
    this.setState({
      startTouches: touches,
      isTouching: true,
      isZoomImageDrag: false
    });
    if (this.detectDoubleTab(touches)) {
      this.cancelEvent(event);
    }
  }

  detectDoubleTab(touches) {
    const time = (new Date()).getTime();
    if (touches.length > 1) {
      this.setState({
        lastTouchStart: null
      });
      return false;
    }
    const isDoubleTap = (time - this.state.lastTouchStart) < 300;
    this.setState({
      lastTouchStart: time
    });
    return isDoubleTap;
  }

  cancelEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  mapTouches(touches) {
    const rect = this.zoomArea.current.getBoundingClientRect();
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
    const posTop = rect.top + scrollTop;
    const posLeft = rect.left + scrollLeft;
    if (touches) {
      if (!this.isTouchDevice) {
        return [{ x: touches.pageX - posLeft, y: touches.pageY - posTop }]
      } else {
        return Array.from(touches).map(touch => ({ x: touch.pageX - posLeft, y: touch.pageY - posTop }));
      }
    }
  }

  onTouchEnd() {
    if (this.props.isDisabled) return;
    this.setState({
      lastTouch: null,
      lastDistance: null,
      lastScale: 1,
      lastZoomCenter: null,
      isTouching: false,
      isScroll: false
    });
  }

  componentDidMount() {
    this.zoomArea.current.addEventListener('touchstart', this.onTouchStart, { passive: false });
    this.zoomArea.current.addEventListener('touchmove', this.onTouchMove, { passive: false });
    this.zoomArea.current.addEventListener('touchend', this.onTouchEnd, { passive: false });

    this.zoomArea.current.addEventListener('mousedown', this.onTouchStart, { passive: false });
    this.zoomArea.current.addEventListener('mousemove', this.onTouchMove, { passive: false });
    this.zoomArea.current.addEventListener('mouseup', this.onTouchEnd, { passive: false });
    if (this.props.imageZoom) {
      setTimeout(() => {
        this.initializeZoomArea();
      }, 100)
    } else {
      this.initializeZoomArea();
    }


    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.externalZoomFactor !== this.props.externalZoomFactor || prevProps.windowWidth !== this.props.windowWidth || (prevProps.isZoomed !== this.props.isZoomed && this.props.isZoomed === false)) {
      this.initializeZoomArea();
    }
    if (this.props.isZoomed && prevState.zoomFactor > this.state.zoomFactor && this.state.zoomFactor === this.getInitialZoomFactor()) {
      this.props.resetZoom(false);
    }

  }
}


function calculateScale(startTouches, endTouches) {
  const startDistance = getDistance(startTouches[0], startTouches[1]);
  const endDistance = getDistance(endTouches[0], endTouches[1]);
  return endDistance / startDistance;
}

function getDistance(a, b) {
  let x, y;
  x = a.x - b.x;
  y = a.y - b.y;
  return Math.sqrt(x * x + y * y);
}